var React = require('react');

function Swoop (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#000","strokeDasharray":"5 13","d":"M1 169c114-16 199-22 256-17 85 7 171 39 256 32 85-8 171-94 256-101 85-8 116 35 254 35 92 0 178-34 258-102"}));
}

Swoop.defaultProps = {"viewBox":"1 1 1280 185"};

module.exports = Swoop;

Swoop.default = Swoop;
